<main class="group-therapy-page">
  <app-success-modal [isVisible]="isSuccessModalVisible" [title]="successTitle" [message]="successMessage"
    (closed)="isSuccessModalVisible = false">
  </app-success-modal>
  <section class="group-hero section animate">
    <div class="container group-container hero-grid">
      <div class="hero-copy">
        <h1>Group Experiences</h1>
        <p>
          Group therapy is not simply therapy in a group, it is a structured,
          clinician led intervention that facilitates:
        </p>
        <img fetchpriority="high" loading="eager" src="assets/img/service/grouptherapy/group_arrow_icon.png" alt=""
          class="hero-arrow" aria-hidden="true">
      </div>

      <div class="hero-media">

        <img fetchpriority="high" loading="eager" src="assets/img/service/grouptherapy/gruop hero.png"
          alt="People taking part in a guided group therapy session" />
      </div>
    </div>

    <div class="container group-container pillar-grid">
      <article class="pillar-card" *ngFor="let pillar of pillars">
        <span class="pillar-icon"><img loading="lazy" decoding="async" [src]="pillar.img" [alt]="pillar.title"></span>
        <div>
          <h2>{{ pillar.title }}</h2>
          <p>{{ pillar.content }}</p>
        </div>
      </article>
    </div>
  </section>

  <section class="group-section intro-section section animate">
    <div class="container group-container split-grid">
      <div class="session-media">
        <img loading="lazy" decoding="async" src="assets/img/service/grouptherapy/group-session.png"
          alt="A clinician guiding a group therapy conversation" />
        <!-- <span class="session-shape"></span> -->
      </div>

      <div class="intro-copy">
        <h2>What Makes Group Work Effective?</h2>
        <p>
          While individual therapy offers depth and personalised attention, it
          can sometimes limit opportunities for learning how you relate to
          others in real situations. Group therapy addresses this gap by
          creating a structured space where individuals can engage with others
          navigating similar emotional experiences.
        </p>
      </div>
    </div>
  </section>

  <section class="group-section section animate approach-section">
    <div class="container group-container approach-grid">
      <div class="approach-copy">
        <p class="eyebrow">Our Approach</p>
        <h2>Structured experiences, not just conversations</h2>
        <p class="lead">
          Every program is a 4-week journey designed to move you from awareness
          to insight to real-life change.
        </p>
        <ul>
          <li>Clinician-led, structured sessions</li>
          <li>Guided reflections and experiential exercises</li>
          <li>Real-time learning in a supportive group</li>
          <li>Closed groups for continuity and trust</li>
          <li>A safe, confidential space to grow</li>
        </ul>
        <a class="dark-button" (click)="scrollToContact()">Contact Us</a>
      </div>

      <article class="format-card">
        <h3>Programme Format</h3>
        <div class="format-row" *ngFor="let row of format">
          <span class="format-icon"><img loading="lazy" decoding="async" [src]="row.img" [alt]="row.label"></span>
          <span>{{ row.label }}</span>
          <strong>{{ row.value }}</strong>
        </div>
        <p>
          A closed-group format that fosters continuity, trust, and deeper
          therapeutic growth.
        </p>
      </article>
    </div>
  </section>

  <section class="themes-section section animate">
    <div class="container">
      <!-- <div class="blur-circle"></div> -->
      <h2 class="section-title">
        <span>Explore</span> Our Current Themes
      </h2>

      <div class="row g-4 gx-5 align-items-start">


        <div class="col-lg-4 themee-menu">
          <div class="theme-menu">

            <div (click)="openTheme(theme)" class="theme-item" [class.active]="showTheme()?.title === theme.title"
              *ngFor="let theme of themes()">
              <div class="theme-left">
                <span class="icon">
                  <img loading="lazy" decoding="async"
                    [src]="showTheme()?.title === theme.title ? theme.imgActive : theme.img" [alt]="theme.title" />
                </span>

                <span class="title">
                  {{ theme.title }}
                </span>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">

                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M1.96263 -0.000342455L2.94395 0.981104L8.16793 6.20512C8.89069 6.92775 8.89069 8.09934 8.16793 8.82197L2.94395 14.046L1.96263 15.0273L0 13.0647L0.981316 12.0834L5.55116 7.51355L0.981316 2.94363L0 1.96236L1.96263 -0.000342455Z"
                  [attr.fill]="showTheme()?.title === theme.title ? '#F5F5F5' : '#797979'" />
              </svg>

              <!-- <i class="fas fa-chevron-right"></i> -->
            </div>

          </div>
        </div>


        <div class="col-lg-8 d-none d-md-block">
          <div class="theme-card" [class.zoom-110]="isZoom110">
            <div class="row align-items-start">
              <!-- Left -->
              <div class="col-md-9">
                <h3>{{ showTheme().title }}</h3>
                <p class="subtitle">{{ showTheme().subtitle }}</p>

                <h5>This space helps you</h5>
                <ul class="help-list">
                  <li *ngFor="let help of showTheme().helps">
                    {{ help }}
                  </li>
                </ul>

                <h5>Program format</h5>
                <p class="program-text">
                  {{ showTheme().format }}
                </p>

                <!-- Mobile Button -->
                <!-- <div class="d-block d-md-none text-end mt-3">
                  <button class="contact-btn" (click)="scrollToContact()">
                    Contact Us
                  </button>
                </div> -->
              </div>

              <!-- Right -->
              <div class="col-md-3 right-section">
                <img loading="lazy" decoding="async" [src]="showTheme().cardImg" [alt]="showTheme().title"
                  class="theme-image" />

                <button class="contact-btn d-block d-md-none mt-3" (click)="scrollToContact()">
                  Contact Us
                </button>

                <!-- Desktop Button -->
                <button class="contact-btn d-none d-md-block" (click)="scrollToContact()">
                  Contact Us
                </button>
              </div>
            </div>

          </div>

        </div>

      </div>
    </div>
  </section>

  <!-- <section class="theme-section section animate">
    <div class="themeContainer container group-container">
      <h2 data-aos="fade-up"><span>Explore</span> Our Current Themes</h2>


      <div class="swiper theme-swiper" data-aos="fade-up" data-aos-delay="200" #swiperRef>

        <div class="swiper-wrapper">

          <article class="theme-card swiper-slide" *ngFor="let theme of themes"
            [class.theme-blue]="theme.tone === 'blue'" [class.theme-cream]="theme.tone === 'cream'"
            [class.theme-mint]="theme.tone === 'mint'">

            <h3 [style.background-color]="theme.backgroundColor">
              <span>
                <img [src]="theme.img" [alt]="theme.title">
              </span>

              {{ theme.title }}
            </h3>

            <p class="theme-subtitle">
              {{ theme.subtitle }}
            </p>

            <h4>This space helps you</h4>

            <ul>
              <li *ngFor="let item of theme.helps">
                {{ item }}
              </li>
            </ul>

            <h4>Program format</h4>

            <p class="format">
              {{ theme.format }}
            </p>

          </article>

        </div>

    
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>

   
        <div class="swiper-pagination"></div>

      </div>


      <div class="contactussect">
        <a class="mint-button" (click)="scrollToContact()">Contact Us</a>
      </div>

    </div>
  </section> -->

  <section class="faq-section section animate">
    <div class="container group-container">
      <h2>Answers to common questions about group therapy<span>.</span></h2>

      <div class="faq-panel">

        <article class="faq-item" *ngFor="let faq of faqs">

          <button type="button" (click)="toggleFaq(faq)">
            <span>
              {{ faq.title }}
            </span>

            <fa-icon [icon]="faq.open ? faChevronUp : faChevronDown" class="fas">
            </fa-icon>
          </button>

          <div class="faq-content" *ngIf="faq.open" @faqAnimation>
            <p [innerHTML]="faq.content"></p>

            <ul *ngIf="faq.points?.length">
              <li *ngFor="let point of faq.points">
                {{ point }}
              </li>
            </ul>

            <p [innerHTML]="faq.contentTwo"></p>
          </div>
        </article>

      </div>
    </div>
  </section>

  <section class="contact-section section animate" id="group-contact">
    <div class="container group-container">
      <div class="contact-card">
        <div class="contact-info">
          <h2>Contact us</h2>
          <p>To learn more about group therapy</p>

          <a href="tel:+9187766554332" class="contact-method">
            <span><img fetchpriority="high" loading="eager" src="assets/img/service/grouptherapy/phone.png"
                alt="Phone"></span>
            <strong>Voice Call</strong>
            <small>9810619251</small>
          </a>

          <a href="https://wa.me/918799877900" class="contact-method">
            <span><img fetchpriority="high" loading="eager" src="assets/img/service/grouptherapy/whatsapp.png"
                alt="WhatsApp"></span>
            <strong>WhatsApp</strong>
            <small>9810619251</small>
          </a>
        </div>

        <form class="contact-form" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label>
              Full Name
              <input type="text" formControlName="fullName" />
              <small class="error" *ngIf="(contactForm.get('fullName')?.touched || submitted) &&
           contactForm.get('fullName')?.hasError('required')">
                Full Name is required
              </small>
            </label>
          </div>
          <div class="form-group">
            <label>
              Age
              <input type="text" formControlName="age" />
              <small class="error" *ngIf="(contactForm.get('age')?.touched || submitted) &&
           contactForm.get('age')?.invalid">
                Please enter a valid age
              </small>
            </label>
          </div>
          <div class="form-group">
            <label>
              Phone Number
              <input type="tel" formControlName="phoneNumber" />
              <small class="error" *ngIf="(contactForm.get('phoneNumber')?.touched || submitted) &&
           contactForm.get('phoneNumber')?.invalid">
                Enter a valid 10 digit phone number
              </small>
            </label>
          </div>
          <div class="form-group">
            <label>
              Email Address
              <input type="email" formControlName="email" />
              <small class="error" *ngIf="(contactForm.get('email')?.touched || submitted) &&
           contactForm.get('email')?.hasError('required')">
                Email is required
              </small>

              <small class="error" *ngIf="(contactForm.get('email')?.touched || submitted) &&
           contactForm.get('email')?.hasError('email')">
                Enter a valid email address
              </small>
            </label>
          </div>
          <div class="form-group">
            <label>
              Location
              <input type="text" formControlName="location" />
              <small class="error" *ngIf="(contactForm.get('location')?.touched || submitted) &&
           contactForm.get('location')?.invalid">
                Location is required
              </small>
            </label>
          </div>


          <div class="form-group multiTab">
            <label>Which group would you like to join?</label>

            <mat-form-field appearance="outline" class="w-100">
              <mat-select formControlName="groups" multiple>
                <mat-select-trigger>
                  <ng-container *ngIf="contactForm.get('groups')?.value?.length">

                    {{ contactForm.get('groups')?.value[0] }}

                    <span *ngIf="contactForm.get('groups')?.value.length > 1">
                      +{{ contactForm.get('groups')?.value.length - 1 }}
                    </span>

                  </ng-container>
                </mat-select-trigger>

                <div class="clear-all-btn" *ngIf="contactForm.get('groups')?.value?.length"
                  (click)="clearGroups($event)"> Clear All </div>
                <mat-option *ngFor="let group of groups" [value]="group">
                  {{ group }}
                </mat-option>

              </mat-select>

              <mat-error *ngIf="
        (contactForm.get('groups')?.touched || submitted) &&
        contactForm.get('groups')?.hasError('required')
      ">
                Please select at least one group
              </mat-error>

            </mat-form-field>
          </div>

          <button type="submit" [disabled]="isSubmitting" class="contact-btn">
            {{ isSubmitting ? 'Submitting...' : 'Submit' }}
          </button>
        </form>
      </div>
    </div>
  </section>
</main>